import { FC, useEffect } from 'react';

import { logEventFirebase } from 'utils/config/firebase';
import { useLocation } from 'react-router-dom';
import { Auth } from 'components/Auth';
import './assets/style/styles.scss';
import Routes from './routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App: FC = () => {
    const location = useLocation();

    useEffect(() => {
        logEventFirebase('page_view', {
            firebase_screen: location.pathname,
        });
    }, [location.pathname]);

    return (
        <>
            <Auth />
            <Routes />
            <ToastContainer />
        </>
    );
};

export default App;
